import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=6ca183c6&scoped=true&"
import script from "./companyInfo.vue?vue&type=script&lang=js&"
export * from "./companyInfo.vue?vue&type=script&lang=js&"
import style0 from "./companyInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./companyInfo.vue?vue&type=style&index=1&id=6ca183c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca183c6",
  null
  
)

export default component.exports